/**
 * @generated SignedSource<<77c63ce3eb0b583cb169c2b14efd1479>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Chain = "Arbitrum" | "Ethereum" | "Optimism" | "POAP" | "Polygon" | "Tezos" | "%future added value";
export type ChainAddressInput = {
  address: string;
  chain: Chain;
};
export type AuthMechanism = {
  debug?: DebugAuth | null;
  eoa?: EoaAuth | null;
  gnosisSafe?: GnosisSafeAuth | null;
};
export type EoaAuth = {
  chainPubKey: ChainPubKeyInput;
  nonce: string;
  signature: string;
};
export type ChainPubKeyInput = {
  chain: Chain;
  pubKey: any;
};
export type GnosisSafeAuth = {
  address: string;
  nonce: string;
};
export type DebugAuth = {
  asUsername?: string | null;
  chainAddresses?: ReadonlyArray<ChainAddressInput> | null;
  userId?: string | null;
};
export type useAddWalletMutation$variables = {
  authMechanism: AuthMechanism;
  chainAddress: ChainAddressInput;
};
export type useAddWalletMutation$data = {
  readonly addUserWallet: {
    readonly __typename: "AddUserWalletPayload";
    readonly viewer: {
      readonly user: {
        readonly wallets: ReadonlyArray<{
          readonly chainAddress: {
            readonly address: string | null;
            readonly chain: Chain | null;
          } | null;
          readonly dbid: string;
        } | null> | null;
      } | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useAddWalletMutation = {
  response: useAddWalletMutation$data;
  variables: useAddWalletMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "authMechanism"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chainAddress"
},
v2 = [
  {
    "kind": "Variable",
    "name": "authMechanism",
    "variableName": "authMechanism"
  },
  {
    "kind": "Variable",
    "name": "chainAddress",
    "variableName": "chainAddress"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbid",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ChainAddress",
  "kind": "LinkedField",
  "name": "chainAddress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chain",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddWalletMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "addUserWallet",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Viewer",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GalleryUser",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Wallet",
                        "kind": "LinkedField",
                        "name": "wallets",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AddUserWalletPayload",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAddWalletMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "addUserWallet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Viewer",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GalleryUser",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Wallet",
                        "kind": "LinkedField",
                        "name": "wallets",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AddUserWalletPayload",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90ea83e08a92ac68d885d377bce9c7ec",
    "id": null,
    "metadata": {},
    "name": "useAddWalletMutation",
    "operationKind": "mutation",
    "text": "mutation useAddWalletMutation(\n  $chainAddress: ChainAddressInput!\n  $authMechanism: AuthMechanism!\n) {\n  addUserWallet(chainAddress: $chainAddress, authMechanism: $authMechanism) {\n    __typename\n    ... on AddUserWalletPayload {\n      __typename\n      viewer {\n        user {\n          wallets {\n            dbid\n            chainAddress {\n              address\n              chain\n            }\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e5364486be8651d19d7e8c27446feac6";

export default node;
